import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="container mx-auto max-w-3xl px-4">
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <h1 className="text-primary-400 text-6xl font-bold mb-4">
          404
        </h1>
        
        <h2 className="text-white text-2xl font-semibold mb-2">
          Page Not Found
        </h2>
        
        <p className="text-gray-400 mb-8 max-w-md">
          The page you are looking for doesn't exist or has been moved.
        </p>
        
        <Link
          to="/"
          className="inline-flex items-center px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-md transition-colors duration-200"
        >
          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
          </svg>
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;